// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetailPPTX from '../../../containers/analytics/pptx/SecurityDetailPPTX';


const SecurityCriticalAcceptableDetailPPTX = ({ data }) => {
  return (
    <SecurityDetailPPTX
      data={data}
      criticality='critical'
      adequacy='acceptable'
    />
  );
};

SecurityCriticalAcceptableDetailPPTX.propTypes = {
  data: PropTypes.object
};

export default SecurityCriticalAcceptableDetailPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/SecurityCriticalAcceptableDetailPPTX.js